var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buy-foot"},[_c('ToBuy',_vm._g(_vm._b({},'ToBuy',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }